<template>
  <div class="container room-info-list" v-if="list.length > 0">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="category">
          <a class="category-top">{{ name }}</a>
          <a class="category-bottom">{{ enname }}</a>
        </div>
      </div>
      <div class="panel-body" style="padding: 0;padding-bottom: 4px">
        <ul class="list-group">
          <li class="list-group-item" v-for="(item, index) in list">
            <van-row type="flex">
              <van-col span="12" @click="showPic(item)" style="height:100%">
                <van-swipe
                  v-if="item.gimages && item.gimages.length > 0"
                  :autoplay="3000"
                  height="100"
                >
                  <van-swipe-item v-for="ite in item.gimages">
                    <!-- <img v-lazy="ite.img_urls"/> -->
                    <van-image :src="ite.img_urls">
                  <template v-slot:loading>
                      <van-loading type="spinner" size="30" />
                  </template>
                      </van-image>
                  </van-swipe-item>
                </van-swipe>
              </van-col>
              <van-col span="12" style="height:100%">
                <ul class="room-info" v-if="name == '客房服务'">
                  <li>
                    <strong class="coloree">{{ item.RoomType }}</strong
                    >
                    <!-- <strong class="price">￥{{ Number(item.Price) }}</strong> -->
                  </li>
                  <li>
                    <b>面积：{{ Number(item.Area) }}&nbsp;平方</b>
                  </li>
                  <li>
                    <b>窗型：{{ item.Window }}</b>
                  </li>
                  <li>
                    <b>客房数量：{{ Number(item.Count) }}&nbsp;间</b>
                  </li>
                  <li><strong class="price">参考价：￥{{Number(item.Price)}}/间</strong> </li>
                </ul>
                <ul class="meeting-info" v-else-if="name == '餐厅包厢'">
                  <li>
                    <strong class="coloree">{{ item.BalconyName }}</strong>
                  </li>
                  <li>
                    <b>面积：{{ Number(item.Area) }}平米</b>
                  </li>
                  <li>
                    <b
                      >座位：{{
                        item.Seats ? Number(item.Seats) + "人" : "-"
                      }}</b
                    >
                  </li>
                  <li>
                    <b
                      >楼层：{{
                        item.Floor ? Number(item.Floor) + "楼" : "-"
                      }}</b
                    >
                  </li>
                  <li>
                    <b>设施：{{item.Facilities }}</b>
                  </li>
                </ul>
                <ul class="meeting-info" v-else-if="(name = '会议服务')">
                  <li>
                    <strong class="coloree">{{ item.MeetingName }}</strong
                    >
                  </li>
                  <li>
                    <b>面积：{{ Number(item.Area) }}平米</b
                    ><b>&nbsp;层高：{{ Number(item.Height) }}米</b>
                  </li>
                  <li>
                    <b
                      >&nbsp;剧院式：{{
                        item.TheaterStyle
                          ? Number(item.TheaterStyle) + "人"
                          : "-"
                      }}</b
                    ><b>&nbsp;课桌式：{{
                      item.DeskStyle ? Number(item.DeskStyle) + "人" : "-"
                    }}</b>
                  </li>
                  <li>
                    <!-- <b
                      >U字型：{{
                        item.UStyle ? Number(item.UStyle) + "人" : "-"
                      }}</b
                    > -->
                    
                  </li>
                  <li>
                    <b
                      >宴会式：{{
                        item.WinePartyStyle
                          ? Number(item.WinePartyStyle) + "人"
                          : "-"
                      }}</b
                    >
                    <b
                      >&nbsp;座谈式：{{
                        item.ForumStyle ? Number(item.ForumStyle) + "人" : ""
                      }}</b
                    >
                  </li>
                  <li><strong class="price"
                      >参考价：￥{{ item.Price ? Number(item.Price) : "-" }}/场
                    </strong>
                  </li>
                </ul>
              </van-col>
            </van-row>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    list: {
      type: Array || Object,
      require: true,
    },
    name: {
      type: String,
      default: "客房服务",
    },
    enname: {
      type: String,
      default: "Guest room",
    },
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  mounted: function () {},
  methods: {
    showPic(item) {
      let images = [];
      for (let i in item.gimages) {
        images[i] = item.gimages[i]["img_urls"];
      }
      if (images.length == 0) return;
      ImagePreview({
        images,
        closeable: true,
      });
    },
  },
};
</script>
<style>
.room-info-list strong,
.room-info-list b {
  font-weight: 800;
}
.room-info-list .list-group-item {
  padding: 4px 12px;
}
.room-info li:first-child {
  display: flex;
}
.meeting-info li:first-child {
  display: flex;
}
/* .room-info li:nth-child(2) {
  margin-top: 2%;
} */
.room-info li b {
  color: #919191;
  font-weight: normal;
}
.meeting-info li b {
  color: #919191;
  font-weight: normal;
}
/* .meeting-info li b:nth-child(2n) {
  margin-left: 2%;
} */
.room-info li .price {
  /* margin-left: 10%; */
  font-weight: 600;
  color: #ff5c59;
}
.meeting-info .price {
  /* margin-left: 10%; */
  font-weight: 600;
  color: #ff5c59;
}
.coloree {
  color: #111820;
  margin-bottom: 2px;
}
.panel-body img{
  height: 100%;
}
</style>
